export default (value) => value && value.replace('  ', ' ')
